module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0137.jpg?v=371449f8";